import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTextToVideoConfig } from '@/data/landingConfig/landingTextToVideoConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TextToVideo } from './schemaObject';

interface Props {}
const TextToVideo: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TextToVideo} />
			<LandingTemplate
				data={landingTextToVideoConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default TextToVideo;
